import React from "react";
import {
  FaUserFriends,
  FaInstagram,
  FaYoutube,
  FaSearch,
  FaTwitter,
  FaBlog,
  FaUsers,
  FaCalendarAlt,
  FaCarrot,
} from "react-icons/fa";
import { IoIosCafe } from "react-icons/io";

// 하위 소스 타입 정의
export interface SubSource {
  id: string;
  label: string;
  type: "button" | "text";
  placeholder?: string;
  subSubSources?: SubSource[];
}

// 소스 타입 정의
export interface Source {
  id: string;
  label: string;
  icon: React.ReactElement;
}

// 하위 소스 데이터
export const subSources: Record<string, SubSource[]> = {
  search: [
    { id: "naver", label: "네이버", type: "button" },
    { id: "google", label: "구글", type: "button" },
    { id: "appstore", label: "앱스토어", type: "button" },
    { id: "playstore", label: "플레이스토어", type: "button" },
    { id: "other", label: "기타", type: "button" },
    {
      id: "how",
      label: "어떻게 검색하셨는지?",
      type: "text",
      placeholder: "검색 방법을 알려주세요",
    },
  ],
  instagram: [
    { id: "ad", label: "광고", type: "button" },
    {
      id: "influencer",
      label: "인플루언서",
      type: "button",
      subSubSources: [
        {
          id: "influencer_name",
          label: "어떤 인플루언서?",
          type: "text",
          placeholder: "인플루언서 이름을 알려주세요",
        },
      ],
    },
    { id: "store_story", label: "매장측 포스팅", type: "button" },
    { id: "friend_post", label: "지인의 포스팅", type: "button" },
    { id: "other", label: "기타", type: "button" },
  ],
  friend: [
    { id: "family", label: "가족", type: "button" },
    { id: "friend", label: "친구", type: "button" },
    { id: "work", label: "직장", type: "button" },
    { id: "other", label: "그외", type: "button" },
  ],
  "mom-cafe": [
    {
      id: "cafe_name",
      label: "맘카페 어느 맘카페인지?",
      type: "text",
      placeholder: "맘카페 이름을 알려주세요",
    },
    {
      id: "content",
      label: "어떤 내용의 글이었는지?",
      type: "text",
      placeholder: "글 내용을 알려주세요",
    },
  ],
  "naver-blog": [
    {
      id: "store_review",
      label: "무슨 매장 후기였는지 궁금해요",
      type: "text",
      placeholder: "매장 후기 내용을 알려주세요",
    },
  ],
  "offline-event": [
    { id: "coffee_truck", label: "커피차", type: "button" },
    { id: "cotton_candy", label: "솜사탕", type: "button" },
    { id: "poster", label: "포스터", type: "button" },
  ],
  community: [
    {
      id: "school_name",
      label: "어느 학교 에브리타임인가요?",
      type: "text",
      placeholder: "학교 이름을 알려주세요",
    },
  ],
};

// 소스 데이터
export const sources: Source[] = [
  { id: "search", label: "검색", icon: <FaSearch /> },
  { id: "instagram", label: "인스타그램", icon: <FaInstagram /> },
  { id: "youtube", label: "유튜브", icon: <FaYoutube /> },
  { id: "friend", label: "지인 소개", icon: <FaUserFriends /> },
  { id: "mom-cafe", label: "맘카페", icon: <IoIosCafe /> },
  { id: "twitter", label: "트위터", icon: <FaTwitter /> },
  { id: "naver-blog", label: "네이버 블로그", icon: <FaBlog /> },
  { id: "community", label: "에브리타임", icon: <FaUsers /> },
  { id: "carrot", label: "당근", icon: <FaCarrot /> },
  { id: "offline-event", label: "오프라인 행사", icon: <FaCalendarAlt /> },
  { id: "other", label: "기타", icon: <FaUserFriends /> },
];

// 타입 추론을 위한 타입 정의
export type SubSourcesType = typeof subSources;
export type SourcesType = typeof sources;

// 소스 ID 타입
export type SourceId = (typeof sources)[number]["id"];

// 하위 소스 ID 타입
export type SubSourceId = string;
